/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Status_ResolvedInputs */

const cs_gdpr_status_resolved = /** @type {(inputs: Gdpr_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znovu aktivní`)
};

const en_gdpr_status_resolved = /** @type {(inputs: Gdpr_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active again`)
};

/**
* | output |
* | --- |
* | "Active again" |
*
* @param {Gdpr_Status_ResolvedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_status_resolved = /** @type {((inputs?: Gdpr_Status_ResolvedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Status_ResolvedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_status_resolved(inputs)
	return cs_gdpr_status_resolved(inputs)
});